import { render, staticRenderFns } from "./Spacer.vue?vue&type=template&id=a2c510b6&scoped=true"
import script from "./Spacer.vue?vue&type=script&lang=js"
export * from "./Spacer.vue?vue&type=script&lang=js"
import style0 from "./Spacer.vue?vue&type=style&index=0&id=a2c510b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c510b6",
  null
  
)

export default component.exports